export enum GoogleRecaptchaActionsType {
  DmWelcome = 'DM_welcome',
  DmPersonalInfo = 'DM_PersonalInfo',
  ApplyProcessPersonalInfo = 'applyProcess_PersonalInfo',
}
